/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Status_InvalidInputs */



/**
* | output |
* | --- |
* | "Invalid email" |
*
* @param {Team_Manager_Import_Status_InvalidInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_status_invalid = /** @type {((inputs?: Team_Manager_Import_Status_InvalidInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Status_InvalidInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("E-mail invalide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ungültige E-Mail")
	if (locale === "it") return /** @type {LocalizedString} */ ("Email non valida")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Неверная почта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Correo no válido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("电子邮件无效")
	if (locale === "ja") return /** @type {LocalizedString} */ ("無効なメール")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अमान्य ईमेल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Email inválido")
	return /** @type {LocalizedString} */ ("Invalid email")
});